<template>
  <page-column>
    <div id="mobile" :style="'overflow-x: hidden;background:' + bgColor">
      <Header :lang="lang"></Header>
      <div>
        <div class="banner-c"><img :src="imageConfig.indexFirst"></div>
      </div>
      <tabs v-model="active" title-active-color="#0b7ce0" color="#0b7ce0" @click="selectedTab">
        <tab :title="status1(lang)"> </tab>
        <tab :title="status(lang)"> </tab>
      </tabs>
      <PullRefresh v-model="isLoading" @refresh="onRefresh">
        <div :style="'background:' + font.newsRightBdColor + 'margin-left:40px'">
          <List class="news-list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div v-for="(news, index) in newsList" style="" @click="getDetail(news)" :key="index">
              <div class="l-title"
                :style="'font-size:' + font.newsTitleSize + ';color:' + font.newsTitleColor + ';font-weight: 600'">
                {{ news.newsTitle }} </div>
              <!-- <div class="l-content"  :style="'font-size:'+font.newsContentSize+';color:'+font.newsContentColor" v-html="news.newsContent"> </div> -->
              <div class="l-content">{{ getTime(news.create_time) }}</div>
            </div>
          </List>
          <!-- <div class="pageComponentsTest" style="margin: 0 auto;">
            <page-component :page-config="pageConfigPageTotal" @changeCurrentPage="changePage"></page-component>
          </div> -->
        </div>
      </PullRefresh>

    </div>
  </page-column>
</template>
<script>

import Header from '../components/mobile/header.vue'
import pageComponent from "../components/pageComponent"
import { Tabs, Tab, PullRefresh, List } from 'vant';
export default {
  name: 'NewsMobile',
  components: {
    Header,
    Tabs,
    Tab,
    PullRefresh,
    List,
    'page-component': pageComponent
  },
  props: {
    lang: {}
  },
  data() {
    return {
      bgColor: '',
      imageConfig: {},
      pageConfigPageTotal: {
        total: null,
        pageSize: 10,
        pageNo: 1,
        pageTotal: null
      },
      font: {},
      active: 0,
      selectedType: 0,
      newsList: [],
      isLoading: false,
      loading: false,
      finished: false,
    }
  },
  mounted() {
    this.getImage()
    this.fetch()
    this.getFontConfig()
  },
  watch: {
    "$route": "onRefresh",
  },
  methods: {
    selectedTab() {
      this.selectedType = this.active
      this.fetch()
    },
    status(key) {
      var map = {
        'zh': '行业新闻',
        'en': 'Industry News',
        'ja': '業界ニュース',
      }
      return map[key]
    },
    status1(key) {
      var map = {
        'zh': '公司新闻',
        'en': 'Press Releases',
        'ja': 'トピックス',
      }
      return map[key]
    },
    async onRefresh() {
      this.pageConfigPageTotal.pageNo = 1
      this.newsList = []
      await this.fetch()
      this.$toast('刷新成功');
      this.isLoading = false;
    },
    async onLoad() {
      this.pageConfigPageTotal.pageNo++
      await this.fetch()
    },
    async fetch() {
      let data = {
        pageSize: 10,
        pageNo: this.pageConfigPageTotal.pageNo,
        language: this.lang,
        type: this.selectedType
      }
      const res = await this.$http.post('newsList', data);
      if (res.data.list.length === 0) {
        this.finished = true
      } else {
        this.newsList = [...res.data.list];
      }
      this.pageConfigPageTotal = {
        total: res.data.pageTotal,
        pageSize: res.data.pageSize,
        pageNo: res.data.pageNo,
        pageTotal: res.data.pageAcount
      }
      this.loading = false;
      console.log(res)
    },
    async getImage() {
      const res = await this.$http.get('imageConfig')
      this.imageConfig = res.data[0] || {}
    },
    getTime(time) {
      const d = time;
      const list = d.split(/[T.]/)
      return list[0];
    },
    async getFontConfig() {
      const res = await this.$http.post('fontConfig')
      const fontContent = res.data
      if (fontContent.length !== 0) {
        this.font = fontContent[0]

      }
    },
    getDetail(news) {
      this.$router.push({path:"/news-detail-mobile/"+this.lang,query:{id:news._id}})
    },
    changePage(page) {
      this.pageConfigPageTotal.pageNo = page;
      this.fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-c {
  height: 6.6rem;

  img {
    margin: 0 auto;
    position: absolute;
    left: 0;
    width: 100%;
  }

}

.news-list {
  padding: .32rem;
  box-sizing: border-box;

  .l-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .l-content {
    font-size: 13px;
    color: #999;
    height: 21px;
    line-height: 20px;
  }
}
</style>
